import React, { useState } from 'react';
import CampaignLogo from '../../CampaignLogo/CampaignLogo';
import NavigationItem from '../NavigationItem/NavigationItem';
import CompetitionLogoImage from '@core/assets/images/logo-brand-competition.svg';
import { MenuItemPlaceholder } from '@core/frontend/ui';
import classes from './MainMenu.module.scss';
import { IconExternalLink } from '@tabler/icons-react';
import { Button, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { useNavMenuConfig } from '../../../stores/index.js';
import CustomStyledText from '../../CustomStyledText/CustomStyledText.jsx';
import { mergeClassNames } from '@core/shared';

const MainMenu = ({ primaryNavigation, primaryNavigationCTA }) => {
    const [isOpen, setIsOpen] = useState(false);
    const {
        logoUrl: customCompetitionLogoUrl,
        navElementsStyle,
        backgroundColor: navBackgroundColor,
        activeElement: {
            hasUnderline: hasActiveUnderline,
            colorTheme: activeColorTheme,
            colorOnlyUnderline: activeColorOnlyUnderline,
        } = {},
    } = useNavMenuConfig();
    const competitionLogoSrc = customCompetitionLogoUrl || CompetitionLogoImage;

    const navbarStyle = {};
    if (navBackgroundColor) {
        navbarStyle.backgroundColor = navBackgroundColor;
    }
    if (navElementsStyle && navElementsStyle.color) {
        navbarStyle['--nav-elements-color'] = navElementsStyle.color;
    }

    const activeClassName = mergeClassNames(
        'active',
        classes.Active,
        activeColorTheme === 'primary' && classes.ActivePrimary,
        activeColorTheme === 'secondary' && classes.ActiveSecondary,
        hasActiveUnderline && classes.ActiveUnderline,
        hasActiveUnderline && activeColorOnlyUnderline && classes.ActiveColorOnlyUnderline
    );

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    let primaryNavContent = (
        <React.Fragment>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
        </React.Fragment>
    );
    let primaryNavCTAContent = '';

    if (primaryNavigation) {
        primaryNavContent = primaryNavigation.map((menuItem, index) => {
            return (
                <NavigationItem key={index} type="header">
                    {/https?:\/\/.*/.test(menuItem.linkTarget) ? (
                        <CustomStyledText
                            tag="a"
                            styleConfig={navElementsStyle}
                            className={classes.NavLink + ` anl_main-menu--lnk-${index + 1} nav-link`}
                            href={menuItem.linkTarget}
                            target="_blank"
                            rel="noopener"
                        >
                            {menuItem.text} <IconExternalLink size={20} className="ms-1" />
                        </CustomStyledText>
                    ) : (
                        <CustomStyledText
                            tag={NavLink}
                            innerTag={RRNavLink}
                            styleConfig={navElementsStyle}
                            className={classes.NavLink + ` anl_main-menu--lnk-${index + 1}`}
                            to={menuItem.linkTarget === '/' ? '/' : menuItem.linkTarget + '/'}
                            exact
                            activeClassName={activeClassName}
                        >
                            {menuItem.text}
                        </CustomStyledText>
                    )}
                </NavigationItem>
            );
        });

        primaryNavCTAContent = primaryNavigationCTA.map((menuItem, index) => {
            return /https?:\/\/.*/.test(menuItem.linkTarget) ? (
                <a href={menuItem.linkTarget} key={index} target="_blank" rel="noopener">
                    <Button color="secondary" className={`anl_main-menu--btn-${index + 1}`}>
                        {menuItem.text}&nbsp;
                        <IconExternalLink size={20} className="ms-1" />
                    </Button>
                </a>
            ) : (
                <Button
                    key={index}
                    color="secondary"
                    to={menuItem.linkTarget}
                    tag={RRNavLink}
                    className={`anl_main-menu--btn-${index + 1}`}
                >
                    {menuItem.text}
                </Button>
            );
        });
    }

    return (
        <Navbar className={classes.Navbar} light expand="lg" style={navbarStyle}>
            <NavbarBrand
                className={`${classes.NavbarBrand} anl_logo--contest`}
                tag={RRNavLink}
                to="/"
                exact
                title="Startseite"
            >
                <CampaignLogo src={competitionLogoSrc} />
            </NavbarBrand>

            <NavbarToggler className="anl_mobile--menu" onClick={toggle} onBlur={toggle} />

            <Collapse className="justify-content-end" isOpen={isOpen} navbar>
                <Nav className="ms-auto" navbar>
                    {primaryNavContent}
                </Nav>
                {primaryNavCTAContent}
            </Collapse>
        </Navbar>
    );
};

export default MainMenu;
